import { connectWithStore } from '../../jsCore/utils/connectWithStore'
import { PostActionsContainerComponent } from './postActions.container'
import { dispatch } from '../../jsCore/application/appStore'
import { fetchPostActions } from '../../jsCore/store/postActions/postActions.actions'
import { getPostId } from '../../jsCore/application/pageDataObject'
import * as mapDispatchToProps from './../../jsCore/store/postActions/postActions.actions'

function mapStateToProps(state) {
  const {
    hasErrors,
    isLoading,
    optionsList,
    shouldFetchOptions,
    fetchFromServer,
  } = state.postActions
  return {
    hasErrors,
    isLoading,
    optionsList,
    shouldFetchOptions,
    fetchFromServer,
  }
}

export const PostActionsContainerWithStore = () => {
  dispatch(fetchPostActions(getPostId(), false))

  return connectWithStore(PostActionsContainerComponent, mapStateToProps, mapDispatchToProps)
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/post_actions/postActionsWithStore.container.js